const email = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
const mobile = /^[1][3,4,5,7,8][0-9]{9}$/;
const integer = /^\d+$|^\d+[.]?\d+$/;
export default {
    install(Vue) {
        /*验证手机号*/
        const isvalidateMobile = (rule, value, callback) => {
            if (value != null && value != "") {
                if (!mobile.test(value)) {
                    callback(new Error("您输入的手机号不正确!"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        };
        /*验证邮箱*/
        const isvalidateEmail = (rule, value, callback) => {
            if (value != null && value != "") {
                if (!email.test(value)) {
                    callback(new Error("邮箱格式不正确!"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        };
        /*请输入数字*/
        const isvalidateInteger = (rule, value, callback) => {
            if (value != null && value != "") {
                if (!integer.test(value)) {
                    callback(new Error("请输入数字!"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        };
        /*含有非法字符(只能输入字母、汉字)*/
        const isvalidateRegexn = (rule, value, callback) => {
            if (value != null && value != "") {
                if (!regexn.test(value)) {
                    callback(new Error("含有非法字符(只能输入字母、汉字)!"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        };

        /**
         * 参数 item
         * required true  必填项
         * maxLength  字符串的最大长度
         * min 和 max 必须同时给 min < max  type=number
         * type 手机号 mobile   邮箱   email   网址   url
         * */

        Vue.prototype.filter_rules = function (item) {
            let rules = [];
            if (item.required) {
                rules.push({
                    required: true,
                    message: "该输入项为必填项!",
                    trigger: "blur"
                });
            }
            if (item.maxLength) {
                rules.push({
                    min: 1,
                    max: item.maxLength,
                    message: "最多输入" + item.maxLength + "个字符!",
                    trigger: "blur"
                });
            }
            if (item.min && item.max) {
                rules.push({
                    min: item.min,
                    max: item.max,
                    message: "字符长度在" + item.min + "至" + item.max + "之间!",
                    trigger: "blur"
                });
            }
            if (item.type) {
                let type = item.type;
                switch (type) {
                    case "email":
                        rules.push({
                            type: "email",
                            validator: isvalidateEmail,
                            trigger: "blur,change"
                        });
                        break;
                    case "mobile":
                        rules.push({
                            validator: isvalidateMobile,
                            trigger: "blur,change"
                        });
                        break;
                    case "regexn":
                        rules.push({
                            validator: isvalidateRegexn,
                            trigger: "blur,change"
                        });
                        break;
                    case "integer":  //只能输入数字
                        rules.push({
                            validator: isvalidateInteger,
                            trigger: "blur,change"
                        });
                        break;
                    default:
                        rule.push({});
                        break;
                }
            }
            return rules;
        };
    }
}